import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { extractErrorMessage } from './extractErrorMessage';
import {
  IServerErrorMessage,
  ServerKnownErrorCode,
} from './IServerErrorMessage';
import { ApplicationHTTPError } from './ApplicationHTTPError';
import { showToastFromController } from '../ToastContext/toastPropsMap';
import { ToastType } from '../ToastContext/interfaces';

let errorHandler: IErrorHandlerPropsMap = null;

interface IHandleErrorArgs {
  error: any;
  context?: any;
  muteError?: boolean;
  preventErrorMonitorReport?: boolean;
}

export interface IErrorHandlerPropsMap {
  handleError({ error, context }: IHandleErrorArgs): void;
  showError(errorMessage: string): void;
}

function getErrorMessageKeyByServerError(error: any): string | undefined {
  const response: IServerErrorMessage = error?.response;

  switch (response?.data?.details?.applicationError?.code) {
    case ServerKnownErrorCode.Auth:
      return 'toast.error.permission-denied';
    case ServerKnownErrorCode.DuplicatedParticipantOwner:
      return 'toast.error.duplicate-owner';
    case ServerKnownErrorCode.DuplicatedParticipantMember:
      return 'toast.error.duplicate-member';
    case ServerKnownErrorCode.ApproveAlreadyResolved:
      return 'toast.error.resolved';
    default:
    case ServerKnownErrorCode.AccessError:
    case ServerKnownErrorCode.SectionNotFound:
    case ServerKnownErrorCode.StepNotFound:
      return 'toast.error.server-general';
  }
}

export const errorHandlerPropsMap = async (
  flowAPI?: ControllerFlowAPI,
): Promise<IErrorHandlerPropsMap> => {
  if (errorHandler === null) {
    errorHandler = {
      handleError({ error, context, preventErrorMonitorReport, muteError }) {
        const errorMessageKey = getErrorMessageKeyByServerError(error);
        if (!preventErrorMonitorReport) {
          const response: { headers?: any } | undefined = error?.response;
          if (response?.headers) {
            delete response.headers;
          }
          if (error?.isWixHttpError) {
            const applicationHTTPError = new ApplicationHTTPError(error);
            flowAPI?.errorMonitor?.captureException(applicationHTTPError, {
              tags: {
                context,
                err_code: applicationHTTPError.code,
              },
              contexts: {
                message: error?.message,
                response,
                context,
              },
            });
          } else {
            flowAPI?.errorMonitor?.captureMessage(
              extractErrorMessage(error, context),
              {
                contexts: {
                  message: error?.message,
                  response,
                  context,
                },
              },
            );
          }
        }
        if (errorMessageKey && !muteError) {
          this.showError(errorMessageKey);
        }
      },
      showError(errorMessageKey) {
        showToastFromController(flowAPI, {
          type: ToastType.error,
          key: errorMessageKey,
        });
      },
    };
  }

  return errorHandler;
};

export function handleError(args: IHandleErrorArgs) {
  errorHandlerPropsMap()
    .then((handler) => {
      handler.handleError(args);
    })
    .catch(console.error);
}
